export default __webpack_public_path__ + "static/media/ganapathi.ab7dc3b0.png";